import React from 'react';
import Banner from './Banner';
// import Categories from './Categories';
// import MostPopular from './MostPopular';
import NewArrival from './NewArrival';
import TrandingProducts from './TrandingProducts';
import Campaign from './Campaign';

const Home = () => {
    return (
        <div>
            <Banner></Banner>
            {/* <Campaign></Campaign> */}
            {/* <Categories></Categories> */}
            <NewArrival></NewArrival>
            {/* <MostPopular></MostPopular> */}
            <TrandingProducts></TrandingProducts>
        </div>
    );
};

export default Home;